/* eslint-disable jsx-a11y/anchor-is-valid */
// DEPENDENCIES
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { connect } from "react-redux";
import * as _ from 'lodash';
// ICONS
import { AiFillMinusCircle, AiFillPlusCircle } from 'react-icons/ai';
// COMPONENTS
import { Spinner, Modal, Button, Form, ListGroup } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { NavLink, Link } from 'react-router-dom';
import Select from 'react-select'
// CUSTOM COMPONENTS
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import ListContainer from '../../../../components/ListContainer';
import ActionBlock from '../../../../components/ActionBlock';
import * as alert from '../../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import * as helper from '../../../../../helpers/helper';
import * as jobService from "../../../../../services/service/jobService";
import JobGeneralInfoValidator from "../../../../../helpers/validators/JobGeneralInfoValidator";
import * as trainingTypeService from '../../../../../services/companyData/trainingTypeService';
import * as trainingSubTypeService from '../../../../../services/companyData/trainingSubTypeService'
import * as credentialService from '../../../../../services/training/credentialService';
import * as jobCredentialService from '../../../../../services/service/jobCredentialService';
import * as jobCredentialAndBlockService from '../../../../../services/service/jobCredentialAndBlockService';

const JobCredentialConditionalBlock = (props) => {
    const { availableCredentials, jobId, savedJobCredentialAndBlock, setSavedJobCredentialAndBlock, showAlert, hideAlert, showConfirmModal, hideConfirmModal, setProcessing } = props;
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState([]);
    const [andBlockCredentials, setAndBlockCredentials] = useState([]);
    const [orBlockCredentials, setOrBlockCredentials] = useState([]);
    const [omitCredentials, setOmitCredentials] = useState([]);

    useEffect(() => {
        if (availableCredentials.length > 0) {
            if (omitCredentials.length === 0) {
                setOptions(availableCredentials.map(x => helper.setToOptionModel(x.name, x.credentialId)));
            } else {
                setOptions(availableCredentials.filter(x => !omitCredentials.includes(x.credentialId)).map(x => helper.setToOptionModel(x.name, x.credentialId)));
            }
        }

    }, [availableCredentials]);

    useEffect(() => {
        if (savedJobCredentialAndBlock.length > 0) {
            fillAndOrSections(savedJobCredentialAndBlock);
        }
    }, [savedJobCredentialAndBlock]);

    const fillAndOrSections = (block) => {
        let andBlockCreds = [...andBlockCredentials];
        let orBlockCreds = [...orBlockCredentials];
        let credentialIdToOmit = [...omitCredentials];

        block.forEach(x => {
            if (x.credentialId === null) {
                let temp = [];
                x.jobCredentialOrBlocks.forEach(y => {
                    temp.push({
                        id: y.id,
                        name: getNameByCredentialId(y.credentialId),
                        credentialId: y.credentialId
                    });
                    credentialIdToOmit.push(y.credentialId);
                });
                orBlockCreds.push(temp);
            } else {
                andBlockCreds.push({
                    id: x.id,
                    name: getNameByCredentialId(x.credentialId),
                    credentialId: x.credentialId
                });
                credentialIdToOmit.push(x.credentialId);
            }
        });

        setAndBlockCredentials(andBlockCreds);
        setOrBlockCredentials(orBlockCreds);
        setOmitCredentials(credentialIdToOmit);
        setOptions(options.filter(x => !credentialIdToOmit.includes(x.value)));
    }

    const getNameByCredentialId = (id) => {
        let credential = availableCredentials.find(x => x.credentialId == id);

        return credential ? credential.name : "NOT FOUND IN THE SYSTEM";
    }

    const saveJobCredentialAndBlock = (isOrBlock) => {
        if (selectedOption.length === 0) {
            return;
        }

        if (isOrBlock && selectedOption.length < 2) {
            showAlert({ message: "Please select at least two credential for OR block", variant: 'warning' });
            return;
        }

        var postObj = (isOrBlock) ? [{
            jobId: jobId,
            jobCredentialOrBlocks: selectedOption.map(x => { return { credentialId: x.value } })
        }] : selectedOption.map(x => {
            return {
                jobId: jobId,
                credentialId: x.value
            }
        })

        jobCredentialAndBlockService.saveJobCredentialAndBlock(postObj).then(res => {
            fillAndOrSections(res);
            setSelectedOption([]);
        }).catch(ex => console.log(ex));
    }

    const deleteJobCredentialBlock = (id, isOrBlock, credentialId, parentArrayIndex = 0) => {
        setProcessing();
        jobCredentialAndBlockService.deleteJobCredentialAndBlock(id, isOrBlock).then(res => {
            if (isOrBlock) {
                let temp = [...orBlockCredentials];
                if (temp[parentArrayIndex].length === 1) {
                    temp.splice(parentArrayIndex, 1);
                } else {
                    temp[parentArrayIndex] = temp[parentArrayIndex].filter(x => x.id != id);
                }

                setOrBlockCredentials(temp);
            } else {
                setAndBlockCredentials(andBlockCredentials.filter(x => x.id != id));
            }
            retreiveOption(credentialId);
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))
            .finally(() => hideConfirmModal());
    }

    const retreiveOption = (id) => {
        let allOptions = [...availableCredentials];
        let tempOmittedCredentials = [...omitCredentials];
        _.remove(tempOmittedCredentials, x => x === id); //18
        setOmitCredentials(tempOmittedCredentials);
        setOptions(allOptions.filter(x => !tempOmittedCredentials.includes(x.credentialId)).map(x => helper.setToOptionModel(x.name, x.credentialId)));
    }


    return (
        <>
            <div className="row">
                <label className="col-xl-3"></label>
                <div className="col-lg-9 col-xl-6">
                    <h5 className="mt-lg-2 mb-6 fz-md fw-700 c-primary">Job Credential Conditionals</h5>
                </div>
            </div>
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                    Credential
                </label>
                <div className="col-lg-9 col-xl-9">
                    <Select
                        isMulti
                        closeMenuOnSelect={false}
                        value={selectedOption}
                        options={options}
                        onChange={setSelectedOption}
                        name="trainingTypeId"
                        placeholder="Select Credential"
                    />
                </div>
            </div>
            <div className="form-group row">
                <div className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                </div>
                <div className="col-lg-9 col-xl-9 d-flex justify-content-end mb-5">
                    <div className="d-flex">
                        <button type="button" onClick={() => saveJobCredentialAndBlock(false)} className="btn btn-primary">Add <strong>AND</strong> Block</button> &nbsp;
                    </div>
                    <div className="d-flex">
                        <button type="button" onClick={() => saveJobCredentialAndBlock(true)} className="btn btn-info">Add <strong>OR</strong> Block</button>
                    </div>
                </div>


                <ContentBlock cols={6}>
                    <CustomBlock className="droppable-area-block">
                        <ContentHeader
                            title={<span><u>AND</u> Group Block</span>}
                            headerSize={"md"}
                        />

                        <ListContainer>
                            {
                                andBlockCredentials.length === 0 ? <p>No current and conditions</p> :
                                    andBlockCredentials.map((section, index) =>
                                        <ActionBlock
                                            key={section.id}
                                            title={section.name}
                                            size="sm"
                                            className="ml-0"
                                            toggleIconPosition="right"
                                            toggleIconBackground="lighter-blue--bg"
                                            toggleIcon={
                                                <AiFillMinusCircle size={23} className="danger--clr" />
                                            }
                                            toggleIconOnClick={() => {
                                                showConfirmModal({
                                                    title: "Remove Credential Condition",
                                                    text: "Are you sure you want to remove this credential condition?",
                                                    rightBtnText: "Confirm",
                                                    btnAction: () => deleteJobCredentialBlock(section.id, false, section.credentialId)
                                                })
                                            }}
                                        />
                                    )
                            }
                        </ListContainer>

                    </CustomBlock>
                </ContentBlock>

                <ContentBlock cols={6}>
                    <CustomBlock className="droppable-area-block--border-none">
                        <ContentHeader
                            title={<span><u>OR</u> Group Block</span>}
                            headerSize={"md"}
                        />
                        {
                            orBlockCredentials.length === 0 ? <p>No current or conditions</p> :
                                orBlockCredentials.map((x, i) => (
                                    <CustomBlock key={i} className="droppable-area-block" style={{ minHeight: '100%' }}>
                                        <ListContainer className="mb-0">
                                            {
                                                orBlockCredentials[i].map((section, index) =>
                                                    <ActionBlock
                                                        key={section.id}
                                                        title={section.name}
                                                        size="sm"
                                                        className={`ml-0 ${index === orBlockCredentials[i].length - 1 ? "mb-0" : ""}`}
                                                        backgroundColor="light--bg"
                                                        toggleIconPosition="right"
                                                        toggleIconBackground="lighter-blue--bg"
                                                        toggleIcon={
                                                            <AiFillMinusCircle size={23} className="danger--clr" />
                                                        }
                                                        toggleIconOnClick={() => {
                                                            showConfirmModal({
                                                                title: "Remove Credential Condition",
                                                                text: "Are you sure you want to remove this credential condition?",
                                                                rightBtnText: "Confirm",
                                                                btnAction: () => deleteJobCredentialBlock(section.id, true, section.credentialId, i)
                                                            })
                                                        }}
                                                    />
                                                )
                                            }
                                        </ListContainer>
                                    </CustomBlock>
                                ))
                        }
                    </CustomBlock>
                </ContentBlock>
            </div>
        </>
    )
}

export default connect(null, { ...alert.actions, ...confirmModal.actions })(JobCredentialConditionalBlock);